import { render, staticRenderFns } from "./studelayoutapply.vue?vue&type=template&id=248d6390&scoped=true"
import script from "./studelayoutapply.vue?vue&type=script&lang=js"
export * from "./studelayoutapply.vue?vue&type=script&lang=js"
import style0 from "./studelayoutapply.vue?vue&type=style&index=0&id=248d6390&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d6390",
  null
  
)

export default component.exports